/* eslint-disable jira/filename-case */
let isInStaticFallbackContext = false;

export function setStaticFallbackContext(value: boolean): void {
	isInStaticFallbackContext = value;
}
export function getStaticFallbackContext(): boolean {
	return isInStaticFallbackContext;
}
